import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class TourService {
    private static readonly TOUR_DATA: string = "tourData";

    constructor() {
        this.tourEndedSource = new Subject<void>();
        this.tourEnded = this.tourEndedSource.asObservable();
    }

    public isTourDone(key: string): boolean {
        let map = this.getMap();
        return map[key] || false;
    }

    public getTourDoneVersion(key: string): number {
        let map = this.getMap();
        let tourData = map[key];
        if (tourData && tourData.done && tourData.version) return tourData.version;
        else return 0;
    }

    public setTourState(key: string, done: boolean, version: number): void {
        let map = this.getMap();
        map[key] = { done: done, version: version };
        localStorage.setItem(TourService.TOUR_DATA, JSON.stringify(map));
        this.tourEndedSource.next();
    }

    private getMap(): any {
        let map: { [key: string]: boolean } = JSON.parse(localStorage.getItem(TourService.TOUR_DATA)) || {};
        return map;
    }

    public remove(key: string) {
        let map = this.getMap();
        delete map[key];
        localStorage.setItem(TourService.TOUR_DATA, JSON.stringify(map));
    }

    public raiseTourEnded() {
        this.tourEndedSource.next();
    }

    private tourEndedSource: Subject<void>;
    public readonly tourEnded: Observable<void>;
}